// @flow

import React, { type Node } from 'react';
import speiBrandSrc from './ico-spei.svg';

export function DisplaySpeiBrands(): Node {
  return (
    <div>
      <img src={speiBrandSrc} alt="spei"></img>
    </div>
  );
}
